/*
 * @Description:
 * @version:
 * @Author: 陈朋
 * @Date: 2021-11-17 16:40:31
 * @LastEditTime: 2021-11-19 09:53:11
 */
import { HttpService } from "@/core";
import {
  ServiceClassificationReq,
  ServiceClassificationPageResp,
  ServiceClassificationDetailResp,
  ServiceClassification,
} from "./service-classification.interface";
import { WorkOrderSimpleListResp } from "../workOrder/workOrder.interface";

export class ServiceClassificationService {
  //   类型管理
  static useTypePageApi(data = {}) {
    const api = () =>
      HttpService.axios({
        method: "POST",
        url: "/maintenance_ticket_type/list",
        data,
      });
    return HttpService.usePagination<WorkOrderSimpleListResp>(api);
  }
  //   数值管理
  static useServiceClassificationPageApi() {
    const api = (params: ServiceClassificationReq) =>
      HttpService.axios({
        method: "POST",
        url: "/maintenance_service_classification/page",
        data: params,
      });
    return HttpService.usePagination<ServiceClassificationPageResp>(api);
  }
  // 新增 数据值
  static useAddServiceClassificationApi() {
    const api = (data: ServiceClassification) =>
      HttpService.axios({
        method: "POST",
        url: "/maintenance_service_classification/add",
        data,
      });
    return HttpService.useRequest<void>(api);
  }
  // 编辑数据值
  static userEditServiceClassification() {
    const api = (id: string, data: ServiceClassification) =>
      HttpService.axios({
        method: "PUT",
        url: `/maintenance_service_classification/update/${id}`,
        data,
      });
    return HttpService.useRequest<void>(api);
  }
  // 删除数据值
  static useDeleteServiceClassificationApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "DELETE",
        url: `/maintenance_service_classification/delete/${id}`,
      });
    return HttpService.useRequest<void>(api);
  }

  static useDetailApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/maintenance_service_classification/detail/${id}`,
      });
    return HttpService.useRequest<ServiceClassificationDetailResp>(api);
  }

  static useSimpleListApi() {
    const api = (data = {}, url = "/maintenance_service_classification/simple/list") =>
      HttpService.axios({
        method: "POST",
        url: url,
        data,
      });
    return HttpService.usePagination<any>(api);
  }
}
